import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../../../utils/axios';

const initialState = {
    gstRates: [],
    sacCodes: [],
    loading: false,
    error: null
};

const gstSlice = createSlice({
    name: 'gst',
    initialState,
    reducers: {
        setGstRates: (state, action) => {
            state.gstRates = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllGstRates.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAllGstRates.fulfilled, (state, action) => {
                state.loading = false;
                state.gstRates = action.payload?.data.filter((rate) => rate.id !== 1); // Exclude GST rate with id 1
                // 1 id contains 0% GST rate, which is not applicable for tax invoices.
                // console.log("GST rates fetched successfully:", action.payload);
            })
            .addCase(getAllGstRates.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                console.error('Error fetching GST rates:', action.payload);
            });

        builder
            .addCase(getAllSacCodes.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAllSacCodes.fulfilled, (state, action) => {
                state.loading = false;
                state.sacCodes = action.payload;
                // console.log('SAC codes fetched successfully:', action.payload);
            })
            .addCase(getAllSacCodes.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                console.error('Error fetching SAC codes:', action.payload);
            });
    }
});

export const { setGstRates } = gstSlice.actions;

export default gstSlice.reducer;

export const getAllGstRates = createAsyncThunk(
    'gst/getAllGstRates',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`/api/v2/gst-rates`);
            return response.data;
        } catch (error) {
            console.error('Error fetching GST rates:', error);
            return rejectWithValue(
                error.response?.data || { message: 'Failed to fetch GST rates' }
            );
        }
    }
);

export const getAllSacCodes = createAsyncThunk(
    'gst/getAllSacCodes',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`/api/v2/sac-codes`);
            return response.data;
        } catch (error) {
            console.error('Error fetching SAC codes:', error);
            return rejectWithValue(error?.response || { message: 'Failed to fetch SAC codes' });
        }
    }
);